import { ElementSize } from "@shared/types";
import React, { ReactNode } from "react";

export const PageWrapperContext = React.createContext<{
  search: {
    show: boolean;
    value: string;
  };
  setShowSearch: (show: boolean) => void;
  setSearchValue: (value: string) => void;
  setHideMobileFilters: (hideMobileFilters: boolean) => void;
  useMobileFilters: boolean;
  mobileFiltersOpen: boolean;
  setMobileFiltersOpen: (mobileFiltersOpen: boolean) => void;
  useMobileSearch: boolean;
  distanceTop?: number;
  pageSize?: ElementSize;
  titleExtraComponent: ReactNode;
  setTitleExtraComponent: (titleExtraComponent: ReactNode) => void;
  setShouldHideBottomSpacer: (shouldHideBottomSpacer: boolean) => void;
}>({
  search: {
    show: false,
    value: "",
  },
  setShowSearch: () => null,
  setSearchValue: () => null,
  setHideMobileFilters: () => null,
  useMobileFilters: false,
  mobileFiltersOpen: false,
  setMobileFiltersOpen: () => null,
  useMobileSearch: false,
  distanceTop: 0,
  pageSize: undefined,
  titleExtraComponent: undefined,
  setTitleExtraComponent: () => null,
  setShouldHideBottomSpacer: () => null,
});
